import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=a0bf1416&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"
import style0 from "./EventList.vue?vue&type=style&index=0&id=a0bf1416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bf1416",
  null
  
)

export default component.exports